// Filename - pages/index.js

import React from "react";
import '../../assets/css/styles.css';


const Ethics = () => {
    return (
        <div>
            <section class="my-20">
            <h1 class="text-5xl bold font-bold flex items-center w-screen justify-center mt-10 mb-5">Ethical Principles</h1>
            <div class="flex items-center w-screen justify-center">
                <dl class="w-3/5 text-lg">
                    <dt>
                        <h2 class=" text-2xl mt-10 text-center  ">
                            Safety & Responsibility 
                        </h2>
                    </dt>
                    <dd>
                        <p class="mb-3 text-center ">
                            Ensuring our technology operates with the highest safety standards for users and the environment.
                        </p>
                    </dd>
                    <dt>
                        <h2 class="text-2xl mt-10 text-center  ">
                            Sustainability 
                        </h2>
                    </dt>
                    <dd>
                        <p class="mb-3 text-center ">
                            Designing solutions that minimize ecological impact and promote ocean conservation.                    
                        </p>
                    </dd>
                    <dt>
                        <h2 class="text-2xl mt-10 text-center  ">
                            Transparency & Accountability
                        </h2>
                    </dt>
                    <dd>
                        <p class="mb-3 text-center ">
                            Upholding ethical AI practices and responsible decision-making in automation.  
                        </p>              
                    </dd>
                    <dt>
                        <h2 class="text-2xl mt-10 text-center  ">
                            Human-Centric Innovation
                        </h2>
                    </dt>
                    <dd>
                        <p class="mb-3 text-center ">
                            Prioritizing robotics that assist, empower, and improve quality of life rather than replace human roles.                    
                        </p>
                    </dd>
                </dl>
            </div>
            </section>
        </div>
    );
};

export default Ethics;
